export default __webpack_public_path__ + "static/media/vc-ortho-vet-house.928d6711.JPG";